import { Pipe, PipeTransform } from '@angular/core';
import { SortOrder, SortDescriptor } from '../sort/sort';
import { Cell } from './cells/cell';
import { ColumnConfig, ColumnDescriptor, TableViewModel } from './table';

@Pipe({ name: 'getSortingIndicatorClass' })
export class GetSortingIndicatorClassPipe implements PipeTransform {
  transform(fieldname: string, sort: SortDescriptor): string {
    if (sort?.fieldname === fieldname) {
      return sort.order === SortOrder.Ascending ? 'arrow_upward' : 'arrow_downward';
    }
    return 'arrow_upward';
  }
}

@Pipe({ name: 'asTextCell' })
export class AsTextCellPipe implements PipeTransform {
  transform(cell: Cell | string): string | null {
    return typeof cell === 'string' ? cell : null;
  }
}

@Pipe({ name: 'asObjectCell' })
export class AsObjectCellPipe implements PipeTransform {
  transform(cell: Cell | string): Cell | null {
    return typeof cell !== 'string' ? cell : null;
  }
}

function computeWidth(width: string | number | undefined): string | null {
  if (typeof width === 'number') {
    return width.toString() + 'px';
  } else if (typeof width === 'string') {
    return width;
  }
  return null;
}

@Pipe({ name: 'getMinWidth' })
export class GetMinWidthPipe implements PipeTransform {
  transform(config: ColumnConfig): string | null {
    return config ? computeWidth(config.minWidth) : null;
  }
}

@Pipe({ name: 'getMaxWidth' })
export class GetMaxWidthPipe implements PipeTransform {
  transform(config: ColumnConfig): string | null {
    return config ? computeWidth(config.maxWidth) : null;
  }
}

@Pipe({ name: 'rowStatusCss' })
export class RowStatusCssPipe implements PipeTransform {
  transform<T>(item: T, tableViewModel: TableViewModel<T>): any {
    const statusColor = tableViewModel.rowStatusColorFor ? tableViewModel.rowStatusColorFor(item) : null;
    if (!statusColor) {
      return { 'feed-item-status': true };
    }

    switch (statusColor) {
      case 'blue':
        return { 'feed-item-status feed-item-status--blue': true };
      case 'black':
        return { 'feed-item-status feed-item-status--black': true };
      case 'green':
        return { 'feed-item-status feed-item-status--green': true };
      case 'red':
        return { 'feed-item-status feed-item-status--red': true };
      default:
        return { 'feed-item-status feed-item-status--blue': true };
    }
  }
}

@Pipe({ name: 'textDirection' })
export class TextDirectionPipe implements PipeTransform {
  transform<T>(column: ColumnDescriptor<T>): string {
    if (column.alignment) {
      if (column.alignment === 'left') {
        return 'flex-start';
      } else if (column.alignment === 'center') {
        return 'center';
      } else {
        return 'flex-end';
      }
    } else {
      return 'flex-start';
    }
  }
}

@Pipe({ name: 'isSortedProperty' })
export class IsSortedPropertyPipe implements PipeTransform {
  transform<T>(column: ColumnDescriptor<T>, sort: SortDescriptor): boolean {
    return sort?.fieldname === column?.sortOn;
  }
}
